import {
  HandlingUnit,
  HandlingUnitWellKnownNaturalId,
} from '@rygen/rygen-ui/model';

// TODO: - this should be able to use `naturalId` instead of `id` once FICON-188 is complete
// (will require backend changes as well, making use of naturalIdEntityReferenceMapper)
export const DEFAULT_HANDLING_UNIT = Object.freeze(
  new HandlingUnit({
    id: 27,
    name: 'Pallet',
    naturalId: HandlingUnitWellKnownNaturalId.PALLET,
  }),
);
